import { configureStore } from '@reduxjs/toolkit';

import CustomizerReducer from './customizer/CustomizerSlice';
import CompanyReducer from './company/CompanySlice';
import CompanyListReducer from './company/CompanyListSlice';
import DistributorReducer from './distributor/DistributorSlice';
import LegalOfficeReducer from './legalOffice/LegalOfficeSlice';
import SupportOfficeReducer from './supportOffice/SupportOfficeSlice';
import ZoneReducer from './zone/ZoneSlice';
import AuthReducer from './auth/AuthSlice';
import ModalReducer from './modal/ModalSlice';
import NotificationReducer from './notifications/NotificationSlice';
// Legacy slices (kept for backward compatibility)
import DigitalServiceReducer from './digitalService/DigitalServiceSlice';
import BenefitAggregateReducer from './benefitAggregate/BenefitAggregateSlice';
import ProviderReducer from './provider/ProviderSlice';
// New VAS slices
import ValueAddedServiceReducer from './valueAddedService/ValueAddedServiceSlice';
import VASAggregateReducer from './vasAggregate/VASAggregateSlice';
import VASProviderPackageReducer from './vasProviderPackage/VASProviderPackageSlice';

export const store = configureStore({
  reducer: {
    customizer: CustomizerReducer,
    company: CompanyReducer,
    distributor: DistributorReducer,
    companyList: CompanyListReducer,
    auth: AuthReducer,
    legalOffice: LegalOfficeReducer,
    supportOffice: SupportOfficeReducer,
    zone: ZoneReducer,
    modal: ModalReducer,
    notifications: NotificationReducer,
    // Legacy reducers (kept for backward compatibility)
    digitalService: DigitalServiceReducer,
    benefitAggregate: BenefitAggregateReducer,
    provider: ProviderReducer,
    // New VAS reducers
    valueAddedService: ValueAddedServiceReducer,
    vasAggregate: VASAggregateReducer,
    vasProviderPackage: VASProviderPackageReducer,
  },
});

export default store;
